import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import { useForm, Controller } from "react-hook-form"

import { useCallback } from 'react'

const FIELD_OPTIONS = {
  required: true,
  validate: (v) => typeof v === 'string' ? v.trim().length > 0 : v !== null && v !== undefined,
}

export const Rule = ({ type, rule, save, close }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({ defaultValues: { ...rule } });
  const onSubmit = useCallback(async (data) => {
    await save(data)

    close()
  }, [save, close])

  return (
    <Box
      component="form"
      autoComplete="off"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        '& .MuiTextField-root': { m: 1, width: '25ch' },
      }}
    >
      <Card sx={{ maxWidth: 310 }}>
        <CardContent>
          <Controller
            name="expected_amount"
            control={control}
            rules={FIELD_OPTIONS}
            render={({ field }) =>
              <TextField
                label="Expected Amount"
                error={!!errors.expected_amount}
                helperText={errors.expected_amount && "expected amount is invalid"}
                {...field}
              />
            }
          />
          <Controller
            name="min_threshold"
            control={control}
            rules={FIELD_OPTIONS}
            render={({ field }) =>
              <TextField
                label="Min threshold"
                error={!!errors.min_threshold}
                helperText={errors.min_threshold && "min_threshold is invalid"}
                {...field}
              />
            }
          />
          <Controller
            name="exchange"
            control={control}
            rules={FIELD_OPTIONS}
            render={({ field }) =>
              <TextField
                label="Exchange"
                error={!!errors.exchange}
                helperText={errors.exchange && "exchange is invalid"}
                {...field}
              />
            }
          />
          <Controller
            name="left_asset"
            control={control}
            rules={FIELD_OPTIONS}
            render={({ field }) =>
              <TextField
                label="Left Asset"
                error={!!errors.left_asset}
                helperText={errors.left_asset && "left_asset is invalid"}
                {...field}
              />
            }
          />
          <Controller
            name="right_asset"
            control={control}
            rules={FIELD_OPTIONS}
            render={({ field }) =>
              <TextField
                label="Right Asset"
                error={!!errors.right_asset}
                helperText={errors.right_asset && "right_asset is invalid"}
                {...field}
              />
            }
          />
        </CardContent>
        <CardActions>
          <Button size="small" color='primary' type="submit" id='submit_button'>{type === 'create' ? 'Create' : 'Update'}</Button>
          <Button size="small" onClick={close} id='cancel_button'>Cancel</Button>
        </CardActions>
      </Card>
    </Box>
  )
}
